export const csvDefaultHeaderValueGetter = (headerName, injectables, field, headerComponentParams) => {
    const { i18n } = injectables;

    const messageIdPrefix =
        headerComponentParams?.messageIdPrefix || 'app.campaigns.reports.grid.column.header.message';

    return i18n.formatMessage({
        id: `${messageIdPrefix}.${field}`,
        defaultMessage: headerName,
    });
};
